//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[0,"AxisVector",1,"Direction",0],[0,"CreateContainer",1,0],[1,"Cylinder",0,"SelectNXObject",0],[1,"FlexibleBelt",0,"SelectNXObject",0],[0,"Name",1,0],[0,"RollerType",1,0]],[[["cylinder"],"SetCylinder",{},1,0],[["flexibleBelt"],"SetFlexiblebelt",{},1,0]],[]];
SPLM.Mechatronics.RollerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.RollerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.RollerBuilder.RollerTypes = Object.freeze({
    "Winding" : "Winding", "Support" : "Support"});

export default SPLM;